import { defineStore } from 'pinia';
import api from '@/common/utils/api';
import { setPersonProperties } from '@/common/telemetry';

type InfoResponse = {
  license?: {
    keynumber?: string
  }
};

const useInfoStore = defineStore('info', () => {
  const fetchInfo = async (): Promise<InfoResponse> => {
    const { data } = await api.get<InfoResponse>('/api/v2/info');
    return data;
  };

  const fetchAndRegisterLicenseData = async (): Promise<void> => {
    try {
      const data = await fetchInfo();
      const licenseKey = data?.license?.keynumber;
      if (licenseKey) {
        setPersonProperties({
          vz_license_keynumber: licenseKey
        });
      }
    } catch (err) {
      // Silently fail license data registration
    }
  };

  return {
    fetchInfo,
    fetchAndRegisterLicenseData
  };
});

export default useInfoStore;
